import { Box } from "@mui/material";
import React from "react";

/**
 * A functional component that renders a styled Box component
 * serving as a backdrop.
 *
 * @param {Object} position - An object containing CSS style
 * properties to position the Box.
 */

export const Backdrop = ({ position }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        width: 150,
        height: 150,
        backgroundColor: "#6E52FA",
        borderRadius: "75px",
        zIndex: 0,
        ...position,
      }}
    />
  );
};
